<template>
	
	<header class="header" :class="$route.path === '/' ? '' : 'base-header'">
			<nav class="navbar"
					:class="$route.path === '/' ? '' : 'with-background'">
				<div class="container">
					<div class="navbar-brand">
						<a 
							@click="alertMessage()"
							class="navbar-item has-text-white is-size-2 has-text-weight-bold" href="#">
					
						</a>
						<span 
						@click="isMenuOpen = !isMenuOpen"
						role="button" 
						tabindex="0"
						:class="{'is-active': isMenuOpen}" 
						class="navbar-burger burger has-text-white" 
						data-target="navbar-menu">
							<span></span>
							<span></span>
							<span></span>
						</span>
					</div>
					<div 
					id="navbar-menu"
				
					class="navbar-menu">
						<div class="navbar-end">
							<!-- Loop through the navigation items -->



							 <template >

								<a class="navbar-item">
									Welcome : INCUBE Sales</a>
									<router-link
									to="/login"
									class="navbar-item nav-home">
									Logout</router-link>
						

								 
							 </template>


						</div>
					</div>
				</div>
			</nav>
		</header>

</template>


<script>

	export default{

	computed:{
	
	},
	data() {
		return {
			isMenuOpen: false,
    brandName: 'Bazaar',
		}
	},
	methods : {
		alertMessage(){
			alert(this.$route.path)
		}
	 }
	}

	
</script>


<style type="text/css" media="screen">

.header {
  position:absolute;
  width: 100%;

  &.base-header{
    position:inherit;
  }
  .navbar {
    background: transparent;
    min-height: 4.5rem;

    &.with-background {
      background-color : $dark-blue-color;
    }

    &-menu {
      .navbar-item {
        color: $white;
        font-weight: $weight-semibold;
        text-transform: uppercase;

        &:hover {
          background-color: transparent;
          color: $primary;
        }
        
        &:focus{
        background-color :transparent;
      }
      }



      &.is-active {
        .navbar-item { color: $dark; }
      }
    }
  }
}

</style>